// Stub for the admin app's SparkUtilRequestBuilder. PreviewFile uses
// `buildAndExecute` and `pollForCompletion` for the AI-summary flow. In this
// build those entry points reject so the caller surfaces a clean error toast
// rather than crashing.
const notSupported = (name) => () => {
  const err = new Error(
    `SparkUtilRequestBuilder.${name} is not available in this build. AI summary generation is disabled.`
  );
  return Promise.reject(err);
};

export const SparkUtilRequestBuilder = {
  buildAndExecute: notSupported("buildAndExecute"),
  pollForCompletion: notSupported("pollForCompletion"),
};

export default { SparkUtilRequestBuilder };
